import { FlagsmithProviders } from '@mint-lib/flags-envs';
import { EventEmitter } from '@mint-lib/service-locator';

import { type MintAdminServiceLocatorAbstractFactoryContext } from '../types.js';

export type Subscription = (() => void) & {
  flags: string[];
  traits: string[];
  env: string;
};

export type FlagsmithEvents = {
  event: [];
  loadingEvent: [];
  subscriptionAdded: [cb: Subscription];
  subscriptionRemoved: [cb: Subscription];
};

export async function flagsmithEventsAbstractFactory(
  ctx: MintAdminServiceLocatorAbstractFactoryContext,
  name: keyof typeof FlagsmithProviders,
) {
  const eventEmitter = new EventEmitter<FlagsmithEvents>();

  return eventEmitter;
}
